import { render, staticRenderFns } from "./remotePetSelect.vue?vue&type=template&id=79ecb2b2&scoped=true&"
import script from "./remotePetSelect.vue?vue&type=script&lang=js&"
export * from "./remotePetSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ecb2b2",
  null
  
)

export default component.exports